import { memo } from 'react';
import clsx from 'clsx';
import classes from './Error.module.scss';

const Error = ({ children, additionalClasses }) => {
    return <span className={clsx(classes.error, additionalClasses)}>{children}</span>;
};

export default memo(Error);
